export default {"src":"/_next/static/media/vectorIndex.1b47115e.svg","height":756,"width":1378,"blurWidth":0,"blurHeight":0};